import { Configuration, LogLevel, ProtocolMode } from "@azure/msal-browser";

const AzureActiveDirectoryAppClientId: any = process.env.REACT_APP_MS_CLIENT_ID;
const redirectURL = process.env.REACT_APP_SERVER_MS_REDIRECT_URL;
const TenantId: any = process.env.REACT_APP_MS_TENANT_ID;

export const MSAL_CONFIG: Configuration = {
    auth: {
        clientId: AzureActiveDirectoryAppClientId,
        authority: "https://login.microsoftonline.com/"+TenantId,
        redirectUri : redirectURL,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
        },
    },
};

// export const graphConfig = {
//     graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
// };